module.exports = __webpack_public_path__ + "media/land.6d620e9b.svg";